import { createFileRoute, redirect } from "@tanstack/react-router";
import { ApiError, fetchMe, qk } from "@/lib/api";
import { DbAccessPage } from "./-db-access/DbAccessPage";

type Search = { project: string; environment: string; database: string };

/** Opened by guv db proxy / connect: confirm a tunnel to a database with your passkey. Outside the app shell. */
export const Route = createFileRoute("/db-access/$grantId")({
  staticData: { title: "Connect to a database" },
  validateSearch: (s: Record<string, unknown>): Search => ({
    project: typeof s.project === "string" ? s.project : "",
    environment: typeof s.environment === "string" ? s.environment : "",
    database: typeof s.database === "string" ? s.database : "",
  }),
  // Signs you in first if needed; loading `me` also arms the CSRF token that approving needs.
  beforeLoad: async ({ context, location }) => {
    try {
      await context.queryClient.ensureQueryData({ queryKey: qk.me(), queryFn: fetchMe });
    } catch (e) {
      if (e instanceof ApiError && (e.status === 401 || e.code === "unauthorized")) {
        throw redirect({ to: "/login", search: { next: location.href } });
      }
      throw e;
    }
  },
  component: DbAccessPage,
});
